import React from 'react'
import classNames from 'classnames'
import { AsH2, TitleMD } from '@/atoms/Text'
import { ParagraphMD } from '@/atoms/Text/Text'
import { useThemeContext } from '@/contexts/ThemeContext'
import { useTranslate } from '@/utils/translate/translate-client'
import { Maybe } from '@/utils/types'
import { SharingBlock } from '@/views/PayItForward/PayItForwardProjectCheckoutView/CallToAction/SharingBlockSOF'

export interface TheatricalPifShareProps {
  shareUrl: string
  projectName: string
  theatricalSlug: Maybe<string>
  newPifLayout?: boolean
}

export const TheatricalPifShareSection: React.FC<TheatricalPifShareProps> = ({
  shareUrl,
  projectName,
  theatricalSlug,
  newPifLayout,
}) => {
  const { t } = useTranslate('pif')
  const { isDarkMode } = useThemeContext()
  return (
    <div
      className={classNames(
        'photon-paragraph-md mx-2 text-center font-whitney font-medium',
        isDarkMode ? 'bg-black' : 'bg-white',
      )}
    >
      {!newPifLayout && (
        <TitleMD
          id="share-section-title"
          as={AsH2}
          weight="bold"
          className={classNames(isDarkMode && 'text-white', 'text-center py-2')}
        >
          {t('shareProjectTheatricalV2', 'Share {{name}}', { name: projectName })}
        </TitleMD>
      )}
      <ParagraphMD
        weight="medium"
        className={classNames(isDarkMode ? 'text-white' : 'text-[#595A5B]', 'text-center max-w-[600px] mx-auto')}
      >
        {t(
          'togetherWeCanHelpImpact',
          'Together, we reach every corner of the world. Click below to share the movie with family & friends and see the impact of your share.',
        )}
      </ParagraphMD>
      <div className="pb-6 pt-3">
        {theatricalSlug && <SharingBlock projectSlug={theatricalSlug} shareUrl={shareUrl} />}
      </div>
    </div>
  )
}
